var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExportNew = function SvgExportNew(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M19.5 19.003a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5H19v-1Z",
    "data-name": "Pfad 1209"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M5 19.003h14v1H5Z",
    "data-name": "Pfad 1210"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M20 12.503v7a.5.5 0 0 0-.5-.5H19v-6.5a.51.51 0 0 0-.5-.5h-2a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h2a1.5 1.5 0 0 1 1.5 1.5",
    "data-name": "Pfad 1211"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M18.5 22.003h-4.01a4 4 0 0 1-.31-.67.51.51 0 0 0-.47-.33h4.79a.5.5 0 0 0 .5-.5v-.5h.5a.5.5 0 0 0 .5-.5v1a1.5 1.5 0 0 1-1.5 1.5",
    "data-name": "Pfad 1212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M14 8.71v3.793a.5.5 0 0 1-1 0V8.71l.5-.5Z",
    "data-name": "Pfad 1213"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M14.18 21.33a4 4 0 0 0 .31.67h-1.12c-.05-.11-.09-.22-.13-.33a.5.5 0 1 1 .94-.34",
    "data-name": "Pfad 1214"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M14 7.75v.96l-.5-.5-.5.5v-.96a.5.5 0 0 1 1 0",
    "data-name": "Pfad 1215"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M10.28 21.003h3.43a.5.5 0 0 0-.47.67c.04.11.08.22.13.33h-2.75c.05-.11.09-.23.13-.34a.5.5 0 0 0-.31-.63.5.5 0 0 0-.16-.03",
    "data-name": "Pfad 1216"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "m11.65 8.65 1.5-1.5a.483.483 0 0 1 .7 0l1.5 1.5a.5.5 0 0 1-.7.71L14 8.71v-.96a.5.5 0 0 0-1 0v.96l-.65.65a.5.5 0 0 1-.7 0 .5.5 0 0 1 0-.71",
    "data-name": "Pfad 1217"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M11 14.303v.95a.5.5 0 0 1-1 0v-.95l.5.5Z",
    "data-name": "Pfad 1218"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M11 10.503v3.8l-.5.5-.5-.5v-3.8a.5.5 0 1 1 1 0",
    "data-name": "Pfad 1219"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M10.44 21.03a.5.5 0 0 1 .31.63c-.04.11-.08.23-.13.34H9.51a3.3 3.3 0 0 0 .3-.66.49.49 0 0 1 .47-.34.5.5 0 0 1 .16.03",
    "data-name": "Pfad 1220"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "m12.35 14.36-1.5 1.5a.51.51 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 0-.71.5.5 0 0 1 .7 0l.65.65v.95a.5.5 0 0 0 1 0v-.947l.64-.65a.513.513 0 0 1 .71 0 .5.5 0 0 1 0 .71Z",
    "data-name": "Pfad 1221"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M10.07 23.003h3.86a5.5 5.5 0 0 1-.56-1h1.12a5 5 0 0 0 .86 1.15.48.48 0 0 1 .11.54.5.5 0 0 1-.46.31H9a.49.49 0 0 1-.46-.31.48.48 0 0 1 .11-.54 5.2 5.2 0 0 0 .86-1.15h1.11a4.7 4.7 0 0 1-.55 1",
    "data-name": "Pfad 1222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M5 19.003v1h-.5a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5Z",
    "data-name": "Pfad 1223"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M5.5 12.003a.5.5 0 0 0-.5.5v6.5h-.5a.5.5 0 0 0-.5.5v-7a1.5 1.5 0 0 1 1.5-1.5h2a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5Z",
    "data-name": "Pfad 1224"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M5.5 21.003h4.78a.49.49 0 0 0-.47.34 3.3 3.3 0 0 1-.3.66H5.5a1.5 1.5 0 0 1-1.5-1.5v-1a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5",
    "data-name": "Pfad 1225"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M4.66 6.02a7.485 7.485 0 0 1 13.99-1.97 5.99 5.99 0 0 1 4.26 9.4.5.5 0 0 1-.91-.29.5.5 0 0 1 .09-.29 4.87 4.87 0 0 0 .91-2.867 4.987 4.987 0 0 0-4.7-4.98.48.48 0 0 1-.42-.29A6.5 6.5 0 0 0 5.57 6.57a.49.49 0 0 1-.49.433 4.023 4.023 0 0 0-4.08 4 3.93 3.93 0 0 0 .89 2.51.5.5 0 0 1 .11.31.49.49 0 0 1-.5.5.51.51 0 0 1-.39-.18A4.88 4.88 0 0 1 0 11.003a5 5 0 0 1 4.66-4.98Z",
    "data-name": "Pfad 1226"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExportNew);
export default ForwardRef;